module.exports = __webpack_public_path__ + "media/bootstrap-icons/calendar2-x-414e4d75.svg";